import styled from 'styled-components';

import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H1 } from '@r1-frontend/ui-react/components/typography/heading';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Header = styled.section`
    overflow: hidden;
    width: 100%;
    background-color: #EBF5F8;
    margin-bottom: 60px;
    max-height: 406px; 

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-bottom: 40px;
    }
    
    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-bottom: 33px;
        max-height: none; 
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 38px;
    }
`;

export const ImageWrapper = styled.div`
    position: relative;
    height: 406px; 
    width: auto;
    flex-grow: 1;

    img, picture {
        position: absolute;
        display: flex;
        height: 100%;
        width: auto;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        height: 302px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        height: auto;
        margin: 0 -16px;
        width: calc(100% + 32px);
        
        img, picture {
            position: static;
            height: auto;
            width: 100%;
        }
    }
`;

export const Container = styled(WideContainer)`
    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 100%;
    }
`;

export const Title = styled(H1)`
    margin: 0;
    margin-bottom: 0;
    margin-right: 177px;
    width: 600px;
    padding-top: 92px;
    padding-bottom: 110px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-right: 0;
    }
    
    @media (max-width: ${wideBreakpoints.tablet}) {
        padding-top: 82px;
        padding-bottom: 100px;
        width: 328px;
        ${FONTS.H2}
    }
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        padding-top: 32px;
        padding-bottom: 28px;
        order: 2;
    }
`;
